import React from 'react';
import moment from 'moment';
import { Mail } from '@mui/icons-material';
import { blue } from '@mui/material/colors';
import makeStyles from '@mui/styles/makeStyles';
import { Box, Divider, Stack, Typography } from '@mui/material';

import { ActivityCardProps } from '../../types';
import { EmailViewer } from './common/EmailViewer';
import { DealEmailActivity } from '../../api/types';
import { CardContainer } from './common/CardContainer';
import { ActionDirection } from './common/ActionDirection';
import { DateFormats } from '../../../../constants/common';

export const EmailCard = ({ entity }: ActivityCardProps<DealEmailActivity>) => {
  const classes = useStyles();

  const { emailText, emailHTML, directionType, emailTo, emailFrom, emailSubject, createdDateTime } = entity;

  return (
    <CardContainer>
      <Box className={classes.email}>
        <Box className="emailIcon">
          <Mail sx={{ color: 'white', zIndex: 2 }} />
          <ActionDirection isInternal={directionType === 'INTERNAL'} />
        </Box>

        <Stack direction="column">
          {emailSubject && (
            <Typography variant="body1" fontWeight="bold">
              {emailSubject}
            </Typography>
          )}

          <Stack direction="row" gap="0.5rem" alignItems="center">
            {emailFrom && (
              <>
                <Typography color="textSecondary" component="span" variant="subtitle2">
                  Email From:
                </Typography>
                <Typography variant="body1">{emailFrom}</Typography>
              </>
            )}

            {emailTo && (
              <>
                <Typography color="textSecondary" component="span" variant="subtitle2">
                  To:
                </Typography>
                <Typography variant="body1">{emailTo.join(', ')}</Typography>
              </>
            )}
          </Stack>
        </Stack>

        <Typography color="textSecondary" component="span" variant="subtitle2">
          {moment(createdDateTime).format(DateFormats.DateTimeMedium12Hour)}
        </Typography>
      </Box>

      <Divider />

      <EmailViewer text={emailText} html={emailHTML} isSupportSwitchMode />
    </CardContainer>
  );
};

const useStyles = makeStyles({
  email: {
    gap: '1rem',
    width: '100%',
    display: 'grid',
    borderRadius: '0.5rem',
    alignItems: 'flex-end',
    gridTemplateColumns: 'auto 1fr auto',

    '& .emailIcon': {
      display: 'flex',
      padding: '0.6rem',
      alignItems: 'center',
      borderRadius: '100%',
      position: 'relative',
      justifyContent: 'center',
      backgroundColor: blue[500],
    },
  },
});
